import fetch2, { METHOD } from 'Util/fetch';
import getConfig from 'Util/Config';

export const fetchCurrentUserToken = async () => {
  const { userApi } = getConfig() || {};
  const response = await fetch2(`${userApi}/me/session`, {}, METHOD.POST);
  return response;
};

export const fetchCreateCustomToken = async (token) => {
  const { firebase: firebaseConfig } = getConfig() || {};
  const response = await fetch(`${firebaseConfig.authenticationServiceApi}/login`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.text();
};
